import { render, staticRenderFns } from "./underConstruction.vue?vue&type=template&id=1f075e21&scoped=true"
import script from "./underConstruction.vue?vue&type=script&lang=js"
export * from "./underConstruction.vue?vue&type=script&lang=js"
import style0 from "./errors.scss?vue&type=style&index=0&id=1f075e21&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f075e21",
  null
  
)

export default component.exports